/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import { createBrowserHistory as createHistory } from 'history';

// a singleton history object
const history = createHistory({});

export default history;
